export const MAX_PRODUCTS_IN_CART = 4;
